export default {
    cn: {
        apiLocale: 'zh-CN',
        base: '',
        // 
        sort: ['最新', '价格最高到底', '价格最低到高'],
        moreInfo: '了解更多',
        find_out_more: "了解更多",
        noMore: '暂无更多内容',
        itsOver: '已经到底了',
        search: '搜索',
        submit: "提交",
    },
    en: {
        apiLocale: 'en',
        base: 'en',
        // 
        sort: ['Recently added', 'Price high-low', 'Price low-high'],
        moreInfo: 'More info',
        find_out_more: "Find out more",
        noMore: 'No more content for now.',
        itsOver: 'It\'s all over.',
        search: 'Search',
        submit: "Submit",
    }
}